import customSliderBackground from "../../utils/customSliderBackground.js";
import agZoneMainFeature from "../widgets/agZoneMainFeature.js";

import agZoneSeoBlock from "../widgets/agZoneSeoBlock.js";

import customCardWidget from "../../utils/customCardWidget.js";

import agZoneFooterBackground from "../widgets/agZoneFooterBackground.js";
import agZoneFooterCards from "../widgets/agZoneFooterCards.js";
import * as utils from "../../utils/utils.js";

let themeName;
let themeURL;

// -------------------------
// HEADER
function createHeader(sparkThemeConfig) {
  themeName = sparkThemeConfig[0].navItemName;
  themeURL = sparkThemeConfig[0].navItemUrl;

  const themeHeading = "agz-header";
  $(".header").addClass(`${themeHeading}`);

  const svgTicket = `
  <svg xmlns="http://www.w3.org/2000/svg" id="ticket-shape" viewBox="0 0 225 51">
    <g>
      <path class="cls-1"
        d="M214.83,25.5c0,5.65,4.54,10.23,10.17,10.3v15.2H0v-15.06c5.69,0,10.3-4.61,10.3-10.3S5.69,15.33,0,15.33V0h225v15.2c-5.63.07-10.17,4.65-10.17,10.3Z" />
    </g>
  </svg>`;

  const headerStructure = `
 <div class="${themeHeading}InnerContent">
   <div class="top-bar-items">
     <div class="inner-content">
      <div class="search-container"></div>
     </div>
   </div>
   <div class="mid-bar">
     <div class="inner-content">
       <div class="right-panel">
         <div class="panel-icons"></div>
         <a class="ticket-container"></a>
       </div>
     </div>
   </div>
   <div class="bottom-bar">
     <div class="inner-content">
     </div>
   </div>
 </div>`;

  $(`.${themeHeading}`).append(headerStructure);

  const agzTopLinks = $("#static-top-links");
  const headerSearch = $(`.${themeHeading}-content .searchBox`);
  const headerCart = $(`.${themeHeading}-content .viewcart`);
  const headerToggle = $(`.${themeHeading} .mobile-nav-toggle`);
  const headerNav = $(`.${themeHeading} #mainNavigation`);
  const headerLogo = $(`.${themeHeading} .header-logo`);
  const headerTicketText = $(`.${themeHeading} .agZoneTicket`).text();
  const headerTicketUrl = $(`.${themeHeading} .agZoneTicket`).attr("href");

  $(`.${themeHeading} .top-bar-items .inner-content .search-container`).append(
    headerSearch
  );
  $(`.${themeHeading} .mid-bar .right-panel .panel-icons`).prepend(
    headerToggle
  );
  $(`.${themeHeading} .mid-bar .right-panel .panel-icons`).prepend(headerCart);
  $(`.${themeHeading} .mid-bar .right-panel .ticket-container`).prepend(
    svgTicket
  );
  $(`.${themeHeading}InnerContent .top-bar-items .inner-content`).prepend(
    agzTopLinks
  );

  $(headerLogo).attr("aria-label", themeName);
  $(headerLogo).attr("href", themeURL);

  $(`.${themeHeading} .mid-bar .right-panel .ticket-container`).append(
    `<span class="ticket-button">${headerTicketText}</span>`
  );
  $(`.${themeHeading} .mid-bar .right-panel .ticket-container`).attr({
    href: headerTicketUrl,
    "aria-label": `${headerTicketText}`,
  });

  $(`.${themeHeading} .bottom-bar .inner-content`).prepend(headerLogo);
  $(`.${themeHeading} .bottom-bar .inner-content`).append(headerNav);

  $(headerCart).clone().prependTo(".mobile-menu-container .mobile-menu-header");
  utils.removeOldHeader(themeHeading);
  utils.customizeSearchBar(themeHeading, "searchBox", "Search Website");
}

// -------------------------
// HOMEPAGE CONTENT
function createContent() {
  customSliderBackground(
    "agZoneSliderBackground",
    agZoneSliderBackgroundOpts,
    "agz-content"
  );
  agZoneMainFeature();
  agZoneSeoBlock();
  customCardWidget("agZoneCardWidget", agZoneCardWidgetOpts);

  $(".content").empty();
  $(".content").addClass("agz-content");
  const contentStructure = `
      <div class="tier-1-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-2-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-3-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-4-container">
        <div class="inner-content"></div>
      </div>`;

  $(".agz-content").append(contentStructure);

  const agzSlider = $("#agZoneMainFeature");
  $(".agz-content .tier-1-container .inner-content").append(agzSlider);

  const agzSeo = $("#agZoneSeoBlock");
  $(".agz-content .tier-2-container .inner-content").append(agzSeo);

  const agzCards = $("#agZoneCardWidget");
  $(".agz-content .tier-3-container .inner-content").append(agzCards);

  const sponsors = $("#sponsorWidgetContainer");
  $(".agz-content .tier-4-container .inner-content").append(sponsors);

  utils.showContent("agz-content");
  $(".afterContent").remove();
}

// -------------------------
// FOOTER
function createFooter() {
  agZoneFooterBackground();
  agZoneFooterCards();

  const footerClass = "agz-footer";
  $(".footer").addClass(`${footerClass}`);

  const footerStructure = `
    <div class="section-a">
      <div class="top-panel">
        <a class="agzone-logo" href="${themeURL}" aria-label="South Florida Fair & Palm Beach County Expositions"></a>
        <div class="flex-panel">
          <a class="sfflogo" href="/" aria-label=""></a>
          <div class="footer-info"></div>
        </div>
      </div>
      <div class="signup-container"></div>
    </div>
    <div class="section-b">
      <div class="nav-container"></div>
      <div class="copy-container"></div>
    </div>
    <div class="section-c"></div>`;

  // -------------------
  $("#sf-signup-section").remove();
  const agzFooterBase = $(`.${footerClass} .ag-zone-footer .ag-zone-wrapper`);
  const agZoneNav = $(".main-theme-footer .footer-navigation");
  const agCopy = $(".main-theme-footer .copy-container");
  const agInfo = $(".ag-zone-footer .info-data");
  const footerCards = $("#agZoneFooterCards");
  const emailSignup = $(".ag-zone-footer .emailSignup");

  $(agzFooterBase).append(footerStructure);
  $(agzFooterBase).find(".footer-info").append(agInfo);
  $(agzFooterBase).find(".section-b .nav-container").append(agZoneNav);
  $(agzFooterBase).find(".section-c").append(footerCards);
  $(agzFooterBase).find(".copy-container").append(agCopy);
  $(agzFooterBase).find(".signup-container").append(emailSignup);

  $(".emailInputField, .emailInputSubmit").wrapAll(
    '<div class="signup-wrap"></div>'
  );
  $(`.${footerClass} .emailSignup .emailSignupText`).text(
    `Stay up to date with all  Agzone News!`
  );
  $(`.${footerClass} .emailSignup .emailInputSubmit .button`).text("Sign Up");

  utils.customizeSearchBar(footerClass, "emailSignup", "Enter Email...");

  $(".footer .main-theme-footer").remove();
  $(".footer .yesteryear-footer").remove();
  $(".footer .southFlorida-footer").remove();
}

export { createHeader, createContent, createFooter };
